<template>

    <GuideLayout :title="title">

        <div class="flex justify-center font-nexa text-blue text-4xl text-center leading-tight">
            {{ __('Start a healthy habit at the office') }},
            <br />
            {{ __('with PauseFitness') }}
        </div>


        <div class="grid gap-8 grid-cols-1 xl:grid-cols-3 grid-rows-1 mt-8 mb-12 w-full">


            <div class="bg-white text-center p-8 rounded-lg">

                <img src="/images/man-flag.png" alt="man-flag" class="ml-auto mr-auto mt-4 mb-20">

                <div class="text-blue font-nexa text-2xl">{{ __('3x3 minutes a week') }}</div>

                <div class="text-blue text-lg mt-4">{{ __('That\'s all it takes.') }}</div>

            </div>


            <div class="bg-white text-center p-8 rounded-lg">

                <img src="/images/mobile-phone.png" alt="man-flag" class="ml-auto mr-auto mt-4 mb-20">

                <div class="text-blue font-nexa text-2xl">{{ __('User friendly') }}</div>

                <div class="text-blue text-lg mt-4">{{ __('Custom dashboard, tailored for you') }}</div>

            </div>


            <div class="bg-white text-center p-8 rounded-lg">

                <img src="/images/heart-color.png" alt="man-flag" class="ml-auto mr-auto mt-4 mb-20">

                <div class="text-blue font-nexa text-2xl">{{ __('Help and prevent pain') }}</div>

                <div class="text-blue text-lg mt-4">{{
                        __('Achieve a healthy working environment and lifestyle')
                    }}
                </div>

            </div>


        </div>

        <div class="mx-auto flex flex-col justify-start items-center xl:flex-row xl:justify-center xl:items-start">

            <div class="w-[196px] xl:mr-10"></div>

            <Button class="mt-7 mb-10 text-2xl pl-12 pr-12 pt-5 pb-4"
                @click="handle_click_next">
                {{ __('Next') }}
            </Button>

        </div>

    </GuideLayout>

</template>

<script>
import {defineComponent} from 'vue';
import GuideLayout from "@/Layouts/GuideLayout";
import Logo from "@/Components/Logo";
import Link from "@/Components/Link";
import Button from "../../Components/Button";

export default defineComponent({

    props: {
        name: String
    },


    components: {
        GuideLayout,
        Button,
        Logo,
        Link
    },


    computed: {

        title() {
            return this.__(this.name);
        }

    },


    methods: {

        handle_click_next() {

            this.$inertia.visit(
                this.route('startup_guide_choose_categories')
            );

        }

    }


});

</script>

<style scoped>

</style>
